if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      // Sana v35 (15 Sep 2026): the lightbox used to hand the browser a
      // srcset capped at 1946px and let it stretch to the viewport, so on a
      // Retina screen a 1500px file was drawn at ~2x its real pixels and
      // looked soft before any zoom. Now every image in the modal is
      // swapped to the largest rendition the CDN has (width=3000 — the CDN
      // caps at the file's real size) and its on-screen width is capped at
      // (real pixels / devicePixelRatio), so it is never drawn larger than
      // 1:1. A 3000px hero can fill a Retina laptop; a 1500px one stops at
      // half that and stays crisp. The image is centred in the dialog.
      sharpenImages() {
        const dpr = window.devicePixelRatio || 1;
        this.querySelectorAll('img').forEach((img) => {
          if (img.dataset.sanaSharp) return;
          img.dataset.sanaSharp = '1';
          let src = img.currentSrc || img.src;
          try {
            const u = new URL(src, location.href);
            u.searchParams.set('width', '3000');
            src = u.toString();
          } catch (e) {}
          const probe = new Image();
          probe.onload = () => {
            img.removeAttribute('srcset');
            img.removeAttribute('sizes');
            img.src = src;
            img.style.maxWidth = `min(100%, ${probe.naturalWidth}px)`; /* v37: 1:1 CSS px, like RCJ */
            img.style.marginLeft = 'auto';
            img.style.marginRight = 'auto';
          };
          probe.src = src;
        });
      }

      showActiveMedia() {
        this.sharpenImages();
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
